import { render, staticRenderFns } from "./RegisterEducationalVisit.vue?vue&type=template&id=247f8454&scoped=true"
import script from "./RegisterEducationalVisit.vue?vue&type=script&lang=js"
export * from "./RegisterEducationalVisit.vue?vue&type=script&lang=js"
import style0 from "./RegisterEducationalVisit.vue?vue&type=style&index=0&id=247f8454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f8454",
  null
  
)

export default component.exports